import {
    Box,
    Typography,
    Button,
    TextField,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    MenuItem,
    Select,
    FormControl,
    InputLabel,
    Autocomplete,
} from '@mui/material';

// Multi-Modus-Dialog: Plan erstellen/bearbeiten, Übung hinzufügen/bearbeiten.
function PlanDialog({
    open,
    onClose,
    onConfirm,
    dialogType,
    formData,
    onFormData,
    filterKategorie,
    onFilterKategorie,
    filterZielmuskel,
    onFilterZielmuskel,
    kategorien,
    zielmuskeln,
    gefilterteUebungen,
    gefilterteCustomUebungen,
    selectedUebung,
    onSelectUebung,
}) {
    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>
                {dialogType === 'createPlan' && 'Neuer Trainingsplan'}
                {dialogType === 'editPlan' && 'Trainingsplan bearbeiten'}
                {dialogType === 'addUebung' && 'Übung hinzufügen'}
                {dialogType === 'editUebung' && 'Übung bearbeiten'}
            </DialogTitle>
            <DialogContent>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
                    {/* Plan erstellen/bearbeiten */}
                    {(dialogType === 'createPlan' || dialogType === 'editPlan') && (
                        <>
                            <TextField
                                label="Planname"
                                value={formData.name}
                                onChange={(e) => onFormData({ ...formData, name: e.target.value })}
                                fullWidth
                                required
                            />
                            <TextField
                                label="Beschreibung (optional)"
                                value={formData.beschreibung}
                                onChange={(e) => onFormData({ ...formData, beschreibung: e.target.value })}
                                fullWidth
                                multiline
                                rows={3}
                            />
                        </>
                    )}

                    {/* Übung hinzufügen */}
                    {dialogType === 'addUebung' && (
                        <>
                            <Box sx={{ display: 'flex', gap: 2, flexDirection: { xs: 'column', sm: 'row' } }}>
                                <FormControl size="small" fullWidth>
                                    <InputLabel>Kategorie filtern</InputLabel>
                                    <Select
                                        value={filterKategorie}
                                        onChange={(e) => onFilterKategorie(e.target.value)}
                                        label="Kategorie filtern"
                                    >
                                        <MenuItem value="">Alle Kategorien</MenuItem>
                                        {kategorien.map(k => <MenuItem key={k} value={k}>{k}</MenuItem>)}
                                    </Select>
                                </FormControl>

                                <FormControl size="small" fullWidth>
                                    <InputLabel>Zielmuskel filtern</InputLabel>
                                    <Select
                                        value={filterZielmuskel}
                                        onChange={(e) => onFilterZielmuskel(e.target.value)}
                                        label="Zielmuskel filtern"
                                    >
                                        <MenuItem value="">Alle Muskeln</MenuItem>
                                        {zielmuskeln.map(z => <MenuItem key={z} value={z}>{z}</MenuItem>)}
                                    </Select>
                                </FormControl>
                            </Box>

                            <Autocomplete
                                options={[
                                    ...gefilterteUebungen.map(u => ({
                                        id: `standard-${u.id}`,
                                        uebung_id: u.id,
                                        name: u.name,
                                        zielmuskel: u.zielmuskel,
                                        kategorie: u.kategorie,
                                        eigene_uebung: 0
                                    })),
                                    ...gefilterteCustomUebungen.map(u => ({
                                        id: `custom-${u.id}`,
                                        uebung_id: u.id,
                                        name: u.uebung_name,
                                        zielmuskel: u.zielmuskel,
                                        kategorie: u.kategorie,
                                        eigene_uebung: 1
                                    }))
                                ]}
                                getOptionLabel={(option) => `${option.name} (${option.zielmuskel})`}
                                value={selectedUebung}
                                onChange={(e, newValue) => onSelectUebung(newValue)}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Übung suchen"
                                        placeholder="Tippe zum Suchen..."
                                        required
                                    />
                                )}
                                renderOption={(props, option) => {
                                    const { key, ...otherProps } = props;
                                    return (
                                        <li key={key} {...otherProps}>
                                            <Box>
                                                <Typography variant="body1">{option.name}</Typography>
                                                <Typography variant="body2" color="text.secondary">
                                                    {option.zielmuskel} • {option.kategorie}
                                                </Typography>
                                            </Box>
                                        </li>
                                    );
                                }}
                                noOptionsText="Keine Übung gefunden"
                            />

                            <TextField
                                label="Notizen (optional)"
                                value={formData.notizen}
                                onChange={(e) => onFormData({ ...formData, notizen: e.target.value })}
                                fullWidth
                                multiline
                                rows={2}
                            />
                        </>
                    )}

                    {/* Übung bearbeiten */}
                    {dialogType === 'editUebung' && (
                        <>
                            <TextField
                                label="Notizen"
                                value={formData.notizen}
                                onChange={(e) => onFormData({ ...formData, notizen: e.target.value })}
                                fullWidth
                                multiline
                                rows={3}
                            />
                        </>
                    )}
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Abbrechen</Button>
                <Button
                    onClick={onConfirm}
                    variant="contained"
                    disabled={
                        (dialogType === 'createPlan' && !formData.name) ||
                        (dialogType === 'addUebung' && !formData.selectedUebung)
                    }
                >
                    Speichern
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default PlanDialog;
